// Medya seçim gate'i — kütüphane ve upload sekmesi AYNI tarama kuralını paylaşır.
// (Ayrı dosya: MediaPicker.tsx yalnız component export etsin — react-refresh.)

import type { FileScanStatus } from '@api/files';
import type { MediaUploadValue } from '../MediaUpload';

/** Only Clean/Skipped files are servable; Pending/Infected/Failed can't be picked. */
export function isSelectable(status: FileScanStatus): boolean {
  return status === 'Clean' || status === 'Skipped' || status === 'None';
}

/**
 * Upload sekmesinde taze yüklenen dosya, kütüphane sekmesiyle AYNI tarama gate'inden
 * geçmeli. `id` yoksa (BE-dışı uploader) durum doğrulanamaz → seçime izin verme; durum
 * henüz gelmediyse (tarama sürüyor / sorgu yükleniyor) Pending kabul edilir → seçilemez.
 */
export function uploadSelectable(
  upload: MediaUploadValue | null,
  status: FileScanStatus | undefined,
): boolean {
  if (!upload?.id) return false;
  return isSelectable(status ?? 'Pending');
}
